module.exports = __webpack_public_path__ + "img/padlock.501a4e4a.svg";